module.exports = __webpack_public_path__ + "static/media/8_weblink-BoerensportVerhaar_groen.44ba27fb.png";